module.exports = __webpack_public_path__ + "img/main-small.b69603be.svg";